import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import SpinModel from "../../../core/src/model/SpinModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";

export default class SaveRestoreStateRequest implements IRequestBuilder {
    get method() {
        return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/setrestorestate";
    }
  
    get requestData() {
        GameModel.incrementRestoreVersion();
        let lastRestoreVersion = GameModel.restoreVersion;
        let index =
            SpinModel.currentGeneration && SpinModel.generations
            ? SpinModel.generations[SpinModel.currentGeneration].index
            : 0;
        let state = JSON.stringify({
            generation: index,
            roundFinished: SpinModel.roundFinish,
            restoreVersion: GameModel.restoreVersion,
            freespinSelectScreen: SpinModel.freespinSelectScreen,
            featureMode: SpinModel.featureMode
        });
    
        return {
            g: Configs.vendorServer.gameId,
            restoreState: state,
            restoreVersion: lastRestoreVersion,
            sid: GameModel.sessionID
        };
    }
}